import { useQuery } from '@apollo/client/react';
import { Label } from '@optools/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@optools/components/ui/select';
import { GET_AD_EVENT_TYPES } from '@optools/services/operator-gateway/logger/queries';
import { AdEventType } from '@optools/services/operator-gateway/types/generated/graphql';
import { useId } from 'react';

export interface AdEventTypeSelectProps {
  adEventType: AdEventType;
  disabled?: boolean;
  setAdEventType: (adEventType: AdEventType) => void;
}

export function AdEventTypeSelect({
  adEventType,
  disabled,
  setAdEventType,
}: AdEventTypeSelectProps) {
  const id = useId();
  const { data } = useQuery(GET_AD_EVENT_TYPES);

  const onChangeAdEventType = (value: string) => {
    const newAdEventType = data?.adEventTypes?.find((eventType) => eventType.value === value);
    if (newAdEventType) {
      setAdEventType(newAdEventType);
    }
  };

  return (
    <div className="flex flex-col gap-1">
      <Label className="text-xs" htmlFor={id}>
        Ad Type
      </Label>
      <Select
        defaultValue={adEventType.value}
        disabled={disabled}
        value={adEventType.value}
        onValueChange={onChangeAdEventType}>
        <SelectTrigger className="w-full" data-testid="adEventTypesControl" id={id}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent align="center" avoidCollisions={false} side="top">
          {data?.adEventTypes?.map((adType) => (
            <SelectItem key={adType.value} value={adType.value}>
              {adType.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
